import React from "react";
import {useSelector, useDispatch} from "react-redux";
import {ReactComponent as Fold} from "assets/image/Layout/PropertyPanel/ic_accordion_fold.svg";
import {ReactComponent as Unfold} from "assets/image/Layout/PropertyPanel/ic_accordion_unfold.svg";
import styles from "./index.module.scss";
import {toggleComponent} from "store/actions/propertyPanel";

function BaseComponent({title, foldable, children}) {
  const dispatch = useDispatch();
  const folded = useSelector(state => !state.propertyPanel.isOpened[title]);
  const componentFoldHandler = () => {
    dispatch(toggleComponent(title));
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {title}
        {foldable && (
          <button className={styles.fold_btn} onClick={componentFoldHandler}>
            {folded ? <Fold /> : <Unfold />}
          </button>
        )}
      </div>
      {(!foldable || !folded) && <div className={styles.components_wrapper}>{children}</div>}
    </div>
  );
}

export default BaseComponent;
